import ContactForm from "./ContactForm";
import { central, email, tel } from "../data";

export default function ContactSection() {
  return (
    <section id="contato" className="sec">
      <div className="wrap">
        <div className="contact-card">
          <div className="contact-intro">
            <h2 className="h2">Vamos falar do seu caixa</h2>
            <p className="lead" data-reveal>
              Envie sua mensagem e retornamos em horário comercial, de segunda a
              sexta.
            </p>
            <div className="contact-links" data-reveal>
              <a className="link" href={tel(central.phone)}>
                Ligue {central.label}
              </a>
              <a className="link" href={`mailto:${email}`}>
                {email}
              </a>
            </div>
          </div>

          <div data-reveal>
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}
